export default __webpack_public_path__ + "static/media/on-the-phone.6482c4d8.jpeg";